

























































































































































// libs
import DatePicker from 'vue2-datepicker';
import lodash from 'lodash';
import { Vue, Component } from 'vue-property-decorator';
import { faCalendarDay } from '@fortawesome/free-solid-svg-icons';
import { library, dom } from '@fortawesome/fontawesome-svg-core';
import { State } from 'vuex-class';
import 'vue2-datepicker/index.css';

// components
import ImagePrivate from '@/components/common/ImagePrivate.vue';
import UploadImageIdentification from '@/components/common/UploadImageIndentification.vue';
import LoaderComponent from '@components/common/LoaderComponent.vue';

// helpers
import Toast from '@common/helpers/toast';
import ApiHelpers from '@/api/ApiHelper';

// interfaces
import { Patient } from '@/models/patient';

@Component({
  components: {
    DatePicker,
    ImagePrivate,
    UploadImageIdentification,
    LoaderComponent,
  },
})
export default class UpdateDeliveryAddressModal extends Vue {
  @State((state) => state.patient_detail.data) patient!: Patient;
  @State((state) => state.patient_detail.isLoading) isLoading!: boolean;

  private formData: any = {
    postal_number: '',
    prefecture_id: '',
    address: '',
    city_id: '',
    building_name: '',
  };

  private get address() {
    const addresses = this.patient?.addresses || [];

    return addresses.filter((adr) => adr.type === 'DELIVERY')[0];
  }

  mounted() {
    library.add(faCalendarDay);
    dom.watch();

    this.formData = lodash.cloneDeep(this.address) ?? this.formData;
  }

  show() {
    if (!this.address) {
      this.formData = {
        postal_number: this.patient?.postal_number || '',
        prefecture_id: this.patient?.prefecture_id || '',
        address: this.patient?.address || '',
        city_id: this.patient?.city_id || '',
        building_name: this.patient?.building_name || '',
      };
    }
    this.formData = lodash.cloneDeep(this.address) ?? this.formData;
    this.$modal.show('edit-delivery-address');
  }

  getRef(name) {
    return this.$refs[name] as any;
  }

  async saveDeliveryAddress(invalid) {
    if (invalid) {
      (this.$refs.editInfoForm as any).validate();
      return;
    }

    const data = {
      postal_number: this.formData.postal_number,
      prefecture_id: this.formData.prefecture_id,
      address: this.formData.address,
      city_id: this.formData.city_id,
      building_name: this.formData.building_name,
      _method: 'put',
    };

    const formData = new FormData();
    for (const key in data) {
      if (data[key] !== null) {
        formData.append(key, data[key]);
      }
    }

    const payload = {
      id: this.patient.id,
      data: formData,
      address_id: this.address?.id,
    };
    await this.$store.dispatch('patient_detail/updateDeliveryAddress', payload);
    this.$modal.hide('edit-delivery-address');
  }

  searchZipcode() {
    const params = {
      postal_code: this.formData.postal_number,
    };

    ApiHelpers.getApi('ZipcodeApi')
      .getList(params)
      .then((res) => {
        this.formData.prefecture_id = res.address1;
        this.formData.city_id = res.address2;
        this.formData.address = res.address3;
      })
      .catch((error) => {
        Toast.error(error.response.data.message);
      });
  }
}
